<script lang="ts">
  import feature from "@store/feature"
  import type { AdUnit } from "@shared/models/AdUnit/AdUnit"
  import { AdUnitLocation } from "@shared/models/AdUnit/AdUnit"
  import CategoryMenuContentCard from "@components/AdUnit/CategoryMenuContentCard.svelte"
  import ProductCatalogContentCard from "@components/AdUnit/ProductCatalogContentCard.svelte"
  import VendorCatalogContentCard from "@components/AdUnit/VendorCatalogContentCard.svelte"

  export let adUnits: AdUnit[] = []
</script>

{#if feature.activated("merchant/view-ad-units")}
  {#each adUnits as adUnit (adUnit.id)}
    {#if adUnit.location === AdUnitLocation.DesignerCategoryMenu}
      <CategoryMenuContentCard {adUnit} />
    {:else if adUnit.location === AdUnitLocation.DesignerProductCatalog}
      <ProductCatalogContentCard {adUnit} />
    {:else if adUnit.location === AdUnitLocation.DesignerVendorCatalog}
      <VendorCatalogContentCard {adUnit} />
    {/if}
  {/each}
{/if}
